import React from 'react'

function Shifts ({ className, fill }) {
  return (
    <svg fill={fill} className={className} viewBox='0 0 22.857 24'>
      <path
        d='M20.571,54.286H2.286A2.292,2.292,0,0,1,0,52V34.286A2.292,2.292,0,0,1,2.286,32H20.571a2.293,2.293,0,0,1,2.286,2.286V52A2.293,2.293,0,0,1,20.571,54.286ZM2.286,33.143a1.146,1.146,0,0,0-1.143,1.143V52a1.146,1.146,0,0,0,1.143,1.143H20.571A1.146,1.146,0,0,0,21.714,52V34.286a1.146,1.146,0,0,0-1.143-1.143Zm0,0'
        transform='translate(0 -30.286)'/>
      <path d='M320,0h1.143V4.571H320Zm0,0' transform='translate(-302.857)'/>
      <path d='M85.332,0h1.143V4.571H85.332Zm0,0' transform='translate(-80.761)'/>
      <path d='M10.668,138.668H32.382v1.143H10.668Zm0,0' transform='translate(-10.096 -131.239)'/>
    </svg>
  )
}

Shifts.defaultProps = {
  className: 'w-full h-full',
  fill: 'currentColor'
}

export default Shifts
